import React from "react";
import { driveThumb, processImageId } from "../data/categoriesData";

// "How We Work" — dark editorial card grid + production still on the
// right. Mirrors the layout reference shared by the client but rendered
// in Momenta's black-and-white aesthetic.
const PILLARS = [
  {
    title: "End-to-end production",
    body: "From creative direction and casting to props, styling, shoot, and retouch, every detail is managed in-house by the Momenta crew.",
  },
  {
    title: "Fast, reliable turnarounds",
    body: "Efficient timelines designed to support launches, campaigns, and ongoing content needs without compromising craft.",
  },
  {
    title: "Experienced crew",
    body: "A vast, full-service team with the range to pull off any format — ad films, commercial stills, event coverage, or branded content — tailored to your brand.",
  },
  {
    title: "A seamless client experience",
    body: "A refined process makes content creation simple, collaborative, and stress-free from briefing through to final delivery.",
  },
];

export const Process = () => {
  const scrollTo = (id) =>
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-black border-t border-white/5 py-16 sm:py-24 lg:py-28"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7">
            <h2 className="font-serif text-white text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.95] mb-8 sm:mb-12">
              A seamless
              <br />
              <em className="italic font-medium">production</em> experience.
            </h2>

            <div className="flex flex-wrap items-center gap-3 sm:gap-4 mb-12 sm:mb-16">
              <button
                onClick={() => scrollTo("#work")}
                data-testid="process-cta-portfolio"
                className="group inline-flex items-center gap-3 border border-white/40 hover:border-white text-white px-5 sm:px-6 py-3 sm:py-4 text-[11px] tracking-[0.3em] uppercase transition-all"
              >
                <span>Explore Portfolio</span>
                <span className="transition-transform duration-500 group-hover:translate-x-1">→</span>
              </button>
              <button
                onClick={() => scrollTo("#contact")}
                data-testid="process-cta-project"
                className="group inline-flex items-center gap-3 bg-white text-black hover:bg-white/85 px-5 sm:px-6 py-3 sm:py-4 text-[11px] tracking-[0.3em] uppercase transition-colors"
              >
                <span>Start a Project</span>
                <span className="transition-transform duration-500 group-hover:translate-x-1">→</span>
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              {PILLARS.map((p, i) => (
                <div
                  key={p.title}
                  data-testid={`process-card-${i}`}
                  className="bg-white/[0.03] border border-white/10 hover:border-white/30 transition-colors p-6 sm:p-7 min-h-[200px] flex flex-col"
                >
                  <h3 className="font-serif italic text-white text-xl sm:text-2xl lg:text-[26px] font-light tracking-tight leading-snug mb-3">
                    {p.title}
                  </h3>
                  <p className="text-white/65 text-sm font-light leading-relaxed">{p.body}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-neutral-900 border border-white/10">
              <img
                src={driveThumb(processImageId, 1600)}
                alt="Inside the Momenta studio"
                data-testid="process-image"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
